module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "box info-box"
  }, [_c('div', {
    staticClass: "box-header with-border"
  }, [_vm._v("\n        Search By\n      ")]), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Member (Type Here)")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "member_id",
      "filterable": false,
      "label": "name",
      "options": _vm.members,
      "placeholder": "Select Member"
    },
    on: {
      "search": _vm.getMemberRecords,
      "input": _vm.getRecordMemberWise
    },
    model: {
      value: (_vm.member),
      callback: function($$v) {
        _vm.member = $$v
      },
      expression: "member"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "member_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Disbursement Date From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disbursementStartDate),
      expression: "form.disbursementStartDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "disbursementStartDate",
      "placeholder": "Disbursment Start Date"
    },
    domProps: {
      "value": (_vm.form.disbursementStartDate)
    },
    on: {
      "change": _vm.changeFilter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "disbursementStartDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("Disbursement Date To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.disbursementEndDate),
      expression: "form.disbursementEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "disbursementEndDate",
      "placeholder": "Disbursment End Date"
    },
    domProps: {
      "value": (_vm.form.disbursementEndDate)
    },
    on: {
      "change": _vm.changeFilter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "disbursementEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("EMI End Date From")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.startEmiEndDate),
      expression: "form.startEmiEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "startEmiEndDate",
      "placeholder": "Disbursment Start Date"
    },
    domProps: {
      "value": (_vm.form.startEmiEndDate)
    },
    on: {
      "change": _vm.changeFilter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "startEmiEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "date"
    }
  }, [_vm._v("EMI End Date To")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.endEmiEndDate),
      expression: "form.endEmiEndDate"
    }],
    staticClass: "form-control",
    attrs: {
      "type": "date",
      "name": "endEmiEndDate",
      "placeholder": "Disbursment Start Date"
    },
    domProps: {
      "value": (_vm.form.endEmiEndDate)
    },
    on: {
      "change": _vm.changeFilter,
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "endEmiEndDate", $event.target.value)
      }
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Branch")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "branch_id",
      "label": "name",
      "options": _vm.branches,
      "placeholder": "Select Branch"
    },
    on: {
      "input": function($event) {
        return _vm.getBranchWiseCollectionCenter(_vm.branch, _vm.withChangeFilter = true)
      }
    },
    model: {
      value: (_vm.branch),
      callback: function($$v) {
        _vm.branch = $$v
      },
      expression: "branch"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1), _vm._v(" "), (_vm.canAccess('collection-center-create')) ? _c('div', {
    staticClass: "col-md-3"
  }, [_c('label', {
    attrs: {
      "for": "Branch"
    }
  }, [_vm._v("Group")]), _vm._v(" "), _c('v-select', {
    attrs: {
      "name": "collection_center_id",
      "label": "name",
      "options": _vm.colCenters,
      "placeholder": "Select Group",
      "required": ""
    },
    on: {
      "input": function($event) {
        return _vm.getRecordByCollectionCenter(_vm.collectionCenter)
      }
    },
    model: {
      value: (_vm.collectionCenter),
      callback: function($$v) {
        _vm.collectionCenter = $$v
      },
      expression: "collectionCenter"
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_id"
    }
  })], 1) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-3"
  }, [_c('button', {
    staticClass: "btn btn-info",
    on: {
      "click": function($event) {
        return _vm.printViewDisbursementByCollectionCenter(_vm.status = 'disbursed')
      }
    }
  }, [_vm._v("Get Print")])])])])]), _vm._v(" "), (_vm.canAccess('loan-disbursement-view-any')) ? _c('div', {
    staticClass: "info-box"
  }, [_vm._m(0), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(1), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "box-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('label', [_c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.per_page),
      expression: "per_page"
    }],
    staticClass: "form-control input-sm",
    attrs: {
      "name": "per_page",
      "aria-controls": "example1"
    },
    on: {
      "change": [function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.per_page = $event.target.multiple ? $$selectedVal : $$selectedVal[0]
      }, function($event) {
        return _vm.changeFilter()
      }]
    }
  }, [_c('option', {
    attrs: {
      "value": "10"
    }
  }, [_vm._v("10")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "25"
    }
  }, [_vm._v("25")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "50"
    }
  }, [_vm._v("50")]), _vm._v(" "), _c('option', {
    attrs: {
      "value": "100"
    }
  }, [_vm._v("100")])])])]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6 col-xs-6"
  }, [_c('div', {
    staticClass: "input-group pull-right input-group-sm",
    staticStyle: {
      "width": "150px"
    }
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.table_search),
      expression: "table_search"
    }],
    staticClass: "form-control pull-right",
    attrs: {
      "type": "text",
      "name": "table_search",
      "placeholder": "Search"
    },
    domProps: {
      "value": (_vm.table_search)
    },
    on: {
      "keyup": function($event) {
        if (!$event.type.indexOf('key') && _vm._k($event.keyCode, "enter", 13, $event.key, "Enter")) { return null; }
        return _vm.changeFilter()
      },
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.table_search = $event.target.value
      }
    }
  }), _vm._v(" "), _c('div', {
    staticClass: "input-group-btn"
  }, [_c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": function($event) {
        return _vm.changeFilter()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-search"
  })])])])])]), _vm._v(" "), _c('div', {
    staticStyle: {
      "overflow": "auto"
    }
  }, [_c('table', {
    staticClass: "table table-sm table-bordered table-hover"
  }, [_vm._m(2), _vm._v(" "), _c('tbody', _vm._l((_vm.rows), function(row, index) {
    return _c('tr', {
      key: index
    }, [_c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s((index + _vm.pagination.from)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.member_loan_plan) ? _c('i', [_vm._v(_vm._s(row.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.planName(row.plan)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm.planRecoveryType(row.plan)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.planAmt(row)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.disbursementDate)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.emiStartDate)))]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v(_vm._s(_vm._f("myDate")(row.emiEndDate)))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(row.collection_center.name) + " (" + _vm._s(row.collection_center.centerCode) + ")")]), _vm._v(" "), _c('td', [(row.member) ? _c('i', [_vm._v(_vm._s(row.member.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [(row.agent) ? _c('span', [_vm._v(_vm._s(row.agent.name))]) : _vm._e()]), _vm._v(" "), _c('td', {
      staticClass: "hidden-xs"
    }, [_vm._v("\n                  " + _vm._s(row.branch_ledger.ledger.name) + "\n                ")]), _vm._v(" "), _c('td', [_c('div', {
      staticClass: "btn-group"
    }, [_vm._m(3, true), _vm._v(" "), _c('ul', {
      staticClass: "dropdown-menu dropdown-menu-right",
      attrs: {
        "role": "menu"
      }
    }, [(_vm.canAccess('loan-disbursement-view')) ? _c('li', [_c('a', {
      attrs: {
        "title": "Previous Loan"
      },
      on: {
        "click": function($event) {
          return _vm.viewPreviousLoanRecords(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-leanpub"
    }), _vm._v(" Previous Loan\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-create') && (row.advance_emi_security === '' || row.advance_emi_security === null)) ? _c('li', [_c('a', {
      on: {
        "click": function($event) {
          return _vm.advanceSecurity(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Advance Security\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-update')) ? _c('li', [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.status == 'pending'),
        expression: "row.status == 'pending'"
      }],
      on: {
        "click": function($event) {
          return _vm.editModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-pencil"
    }), _vm._v(" Update\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-delete')) ? _c('li', [_c('a', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.status == 'disbursed' || row.status == 'pending'),
        expression: "row.status == 'disbursed' || row.status == 'pending'"
      }],
      on: {
        "click": function($event) {
          return _vm.deleteDisbursment(row.id)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-trash"
    }), _vm._v(" Delete\n                        ")])]) : _vm._e(), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.filechargeStatus == 'exclude'),
        expression: "row.filechargeStatus == 'exclude'"
      }]
    }, [_c('a', {
      attrs: {
        "title": "File Charge"
      },
      on: {
        "click": function($event) {
          return _vm.fileChargeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-file"
    }), _vm._v(" File Charge\n                        ")])]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.processingFeeStatus == 'exclude'),
        expression: "row.processingFeeStatus == 'exclude'"
      }]
    }, [_c('a', {
      attrs: {
        "title": "Processing Fee"
      },
      on: {
        "click": function($event) {
          return _vm.processingFeeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-hourglass"
    }), _vm._v(" Processing Fee\n                        ")])]), _vm._v(" "), _c('li', {
      directives: [{
        name: "show",
        rawName: "v-show",
        value: (row.insuranceFeeStatus == 'exclude'),
        expression: "row.insuranceFeeStatus == 'exclude'"
      }]
    }, [_c('a', {
      attrs: {
        "title": "Insurance Fee"
      },
      on: {
        "click": function($event) {
          return _vm.insuranceFeeModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-user-md"
    }), _vm._v(" Insurance Fee\n                        ")])]), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('li', [_c('a', {
      attrs: {
        "title": "For Staff"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-print"
    }), _vm._v(" Loan Agreement\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('li', [_c('a', {
      attrs: {
        "title": "For Customer"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintCustomerModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-hand-o-up"
    }), _vm._v(" Loan Sanction Letter\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('li', [_c('a', {
      attrs: {
        "title": "Loan EMI Card"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintCustomerEMIModal(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-book"
    }), _vm._v(" Loan EMI Card\n                        ")])]) : _vm._e(), _vm._v(" "), (_vm.canAccess('loan-disbursement-view')) ? _c('li', [_c('a', {
      attrs: {
        "title": "Demand Promissory Note"
      },
      on: {
        "click": function($event) {
          return _vm.viewPrintDimandProbeshnoryNote(row)
        }
      }
    }, [_c('i', {
      staticClass: "fa fa-sticky-note-o"
    }), _vm._v(" Demand Promissory Note\n                        ")])]) : _vm._e()])])])])
  }), 0)])])]), _vm._v(" "), (_vm.pagination.current_page > 0) ? _c('div', {
    staticClass: "box-footer clearfix"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-4"
  }, [_vm._v("\n            Showing " + _vm._s(_vm.pagination.from) + " to " + _vm._s(_vm.pagination.to) + " of " + _vm._s(_vm.pagination.total) + " entries\n          ")]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-8"
  }, [_c('ul', {
    staticClass: "pagination pagination-sm no-margin pull-right"
  }, [_c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'first')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("«")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'prev')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Prev")])]), _vm._v(" "), (_vm.pagination.current_page > 3) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 2) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page > 1) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "active",
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page))])]), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 4)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 1))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 5)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 6)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.current_page + 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.current_page + 3))])]) : _vm._e(), _vm._v(" "), _vm._m(4), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 3)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 3)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 3))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 2)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 2)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 2))])]) : _vm._e(), _vm._v(" "), (_vm.pagination.current_page < (_vm.pagination.last_page - 1)) ? _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page - 1)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page - 1))])]) : _vm._e(), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(_vm.pagination.last_page)
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v(_vm._s(_vm.pagination.last_page))])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'next')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("Next")])]), _vm._v(" "), _c('li', {
    on: {
      "click": function($event) {
        return _vm.changeFilter(null, 'last')
      }
    }
  }, [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("»")])])])])])]) : _vm._e()]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "fileChargeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(5), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(6), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect File Charge ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(7)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "processingFeeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(8), _vm._v(" "), _c('form', {
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(9), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect Processing Fee ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(10)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "insuranceFeeModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-xl"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(11), _vm._v(" "), _c('form', {
    on: {
      "~submit": function($event) {
        $event.preventDefault();
        return _vm.fileChargeProcessingFeeCollect()
      }
    }
  }, [_c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "card card-warning"
  }, [_c('div', {
    staticClass: "card-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Select Ledger Account ")]), _vm._v(" "), _c('select', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.branch_ledger_id),
      expression: "form.branch_ledger_id"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has('branch_ledger_id'),
    },
    attrs: {
      "name": "branch_ledger_id"
    },
    on: {
      "change": function($event) {
        var $$selectedVal = Array.prototype.filter.call($event.target.options, function(o) {
          return o.selected
        }).map(function(o) {
          var val = "_value" in o ? o._value : o.value;
          return val
        });
        _vm.$set(_vm.form, "branch_ledger_id", $event.target.multiple ? $$selectedVal : $$selectedVal[0])
      }
    }
  }, [(!_vm.form.branch_ledger_id) ? _c('option', {
    attrs: {
      "selected": "",
      "value": ""
    }
  }, [_vm._v("\n                              Select Ledger Account\n                            ")]) : _vm._e(), _vm._v(" "), _vm._l((_vm.bank_accounts), function(bank_account) {
    return _c('option', {
      key: bank_account.id,
      domProps: {
        "value": bank_account.id
      }
    }, [_vm._v("\n                              " + _vm._s(bank_account.name) + " " + _vm._s(bank_account.remark) + "\n                            ")])
  })], 2), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "branch_ledger_id"
    }
  })], 1), _vm._v(" "), _c('div', {
    staticClass: "form-group"
  }, [_vm._m(12), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.paymentDate),
      expression: "form.paymentDate"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'paymentDate'
      ),
    },
    attrs: {
      "type": "date",
      "name": "paymentDate",
      "placeholder": "Enter Payment Date",
      "required": ""
    },
    domProps: {
      "value": (_vm.form.paymentDate)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "paymentDate", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "paymentDate"
    }
  })], 1)]), _vm._v(" "), _c('div', {
    staticClass: "col-sm-6"
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('label', [_vm._v("Collect Insurance Fee ")]), _vm._v(" "), _c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.form.amt),
      expression: "form.amt"
    }],
    staticClass: "form-control",
    class: {
      'is-invalid': _vm.form.errors.has(
        'amt'
      ),
    },
    attrs: {
      "type": "text",
      "name": "amt",
      "placeholder": "Please Enter amt",
      "disabled": ""
    },
    domProps: {
      "value": (_vm.form.amt)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.$set(_vm.form, "amt", $event.target.value)
      }
    }
  }), _vm._v(" "), _c('has-error', {
    attrs: {
      "form": _vm.form,
      "field": "amt"
    }
  })], 1)])])])])]), _vm._v(" "), _vm._m(13)])])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(14), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.print()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "print"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed"
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                          "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                          ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.member_loan_plan.applicationNo,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                            Show this if the rendering fails.\n                          ")])], 1)])]), _vm._v(" "), _c('h2', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Loan Agreement")]), _vm._v(" "), (_vm.seeRecord.status == 'disbursed') ? _c('div', [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', {
    staticStyle: {
      "border-width": "1px"
    }
  }, [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Branch : " + _vm._s(_vm.seeRecord.branch.name) + " (" + _vm._s(_vm.seeRecord.branch.branchCode) + ")")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date : " + _vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))])]), _vm._v(" "), _c('tbody', {
    staticStyle: {
      "border-width": "1px"
    }
  }, [_c('tr', [_c('td', [_vm._v("Customer Name ")]), _vm._v(" "), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.name) + " (" + _vm._s(_vm.seeRecord.member.code) + ")")]), _vm._v(" "), _c('td', [_vm._v("Group Name : " + _vm._s(_vm.seeRecord.collection_center.name) + " (" + _vm._s(_vm.seeRecord.collection_center.centerCode) + ")")]), _vm._v(" "), _vm._m(15)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Contact No ")]), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.mobile))]), _vm._v(" "), _c('td', [_vm._v("Gender : " + _vm._s(_vm.mem.gender))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("DOB ")]), _c('td', [_vm._v(" " + _vm._s(_vm._f("myDate")(_vm.mem.dob)))]), _vm._v(" "), _c('td', [_vm._v("Spouse Name  : " + _vm._s(_vm.mem.spouseName))])]), _vm._v(" "), _vm._m(16), _vm._v(" "), _c('tr', [_vm._m(17), _c('td', [_vm._v(" " + _vm._s(_vm.mem.address) + ", " + _vm._s(_vm.mem.area))]), _vm._v(" "), _vm._m(18), (_vm.mem.state) ? _c('td', [_vm._v(" " + _vm._s(_vm.mem.district) + ", " + _vm._s(_vm.mem.state.name) + " - " + _vm._s(_vm.mem.pin))]) : _vm._e()]), _vm._v(" "), _vm._m(19), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Bank : ")]), _vm._v(" "), (_vm.mem.bank) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bank.name))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Branch : ")]), (_vm.mem.bankBranch) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bankBranch))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Loan ID :")]), _vm._v(" "), (_vm.seeRecord.member_loan_plan) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Plan Name :")]), _vm._v(" " + _vm._s(_vm.pl.name))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Account Holder : ")]), _vm._v(_vm._s(_vm.mem.accountHolderName))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Account Number : ")]), _vm._v(" "), (_vm.mem.accountNumber) ? _c('span', [_vm._v(_vm._s(_vm.mem.accountNumber))]) : _vm._e()]), _vm._v(" "), (_vm.myhost === 'demo.microfinancesoftware.in') ? _c('td', [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate (%) : " + _vm._s(_vm.pl.rateOfInterest) + "/12 ")]) : _vm._e()]) : _c('td', [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate (%) : " + _vm._s(_vm.pl.rateOfInterest) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("GST Include : ")]), _vm._v(_vm._s(_vm.pl.includeGst))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("IFSC : ")]), _vm._v(_vm._s(_vm.mem.ifsc))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Loan Amount :")]), _vm._v(" " + _vm._s(_vm.planAmt(_vm.seeRecord)))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("File Charge : ")]), _vm._v(_vm._s(_vm.fileChargeFee(_vm.seeRecord)))])]), _vm._v(" "), _c('tr', [_vm._m(20), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Processing Fee :")]), _vm._v(" " + _vm._s(_vm.processingFee(_vm.seeRecord)))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Insurance Fee :")]), _vm._v(" " + _vm._s(_vm.insuranceFee(_vm.seeRecord)))])]), _vm._v(" "), (_vm.pl.rateOfInterest) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Income (INR) : ")]), _vm._v(_vm._s(_vm.mem.incomeAmount))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Occupation : ")]), _vm._v(_vm._s(_vm.mem.jobType))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Recovery type :")]), _vm._v(" " + _vm._s(_vm.pl.recoveryType))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Amount to be Paid :")]), _vm._v(" "), (_vm.seeRecord.loanAmount) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.loanAmount))]) : _c('span', [_vm._v(" " + _vm._s(_vm.pl.amount))])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Business Name : ")]), _vm._v(_vm._s(_vm.mem.businessName))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Income Type : ")]), _vm._v(_vm._s(_vm.mem.incomeType))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("No of Payments : ")]), _vm._v(" "), (_vm.pl.noOfPayments) ? _c('span', [_vm._v(_vm._s(_vm.pl.noOfPayments))]) : _vm._e()]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Minimum Income : ")]), _vm._v(_vm._s(_vm.mem.minAmount))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Purpose : ")]), (_vm.seeRecord.purpose) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.purpose.purpose))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Description : ")]), _vm._v(_vm._s(_vm.seeRecord.description))])]), _vm._v(" "), _c('tr', [_vm._m(21), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "120px",
      "height": "140px",
      "float": "right",
      "text-align": "center"
    }
  }, [_c('br'), _c('center', [_vm._v("Guarantor Photo "), _c('br'), _vm._v("with Cross Sign")])], 1)])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Name : "), (_vm.seeRecord.guarantor) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.guarantor.name) + " (" + _vm._s(_vm.seeRecord.guarantor.code) + ")")]) : _vm._e()])]), _vm._v(" "), _c('td', [(_vm.seeRecord.guarantor) ? _c('span', [_vm._v("Address : " + _vm._s(_vm.seeRecord.guarantor.member_profile.address))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Contact Number : ")]), (_vm.seeRecord.guarantor) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.guarantor.mobile) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Nominee Name : " + _vm._s(_vm.mem.nomineeName))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Nominee Mobile : ")]), _vm._v(_vm._s(_vm.mem.nomineePhone))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Nominee Dob : ")]), _vm._v(_vm._s(_vm.mem.nomineeDob))])])])]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "1px",
      "width": "100%",
      "font-size": "12px",
      "bottom": "20px"
    }
  }, [(_vm.myhost === 'progati.micromuneem.com' || _vm.myhost === 'bmcf.microfinancesoftware.in') ? _c('thead', [_vm._m(22), _vm._v(" "), _vm._m(23), _vm._v(" "), _vm._m(24)]) : _c('thead', [_vm._m(25), _vm._v(" "), _vm._m(26), _vm._v(" "), _vm._m(27)])]), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _c('h3', [_vm._v("Repayment Schedule Terms ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_vm._m(28), _vm._v(" "), _vm._m(29), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in') ? _c('td', [_c('strong', [_vm._v("Interest")])]) : _vm._e(), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in') ? _c('td', [_c('strong', [_vm._v("Principal")])]) : _vm._e(), _vm._v(" "), _vm._m(30)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.memberEmiRecords), function(memberEmiRecord) {
    return _c('tr', {
      key: memberEmiRecord.id
    }, [_c('td', [_vm._v(_vm._s(memberEmiRecord.emiNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(memberEmiRecord.emiDate))]), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in') ? _c('td', [_vm._v(_vm._s(memberEmiRecord.intrest))]) : _vm._e(), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in') ? _c('td', [_vm._v(_vm._s(memberEmiRecord.principal))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(memberEmiRecord.total))])])
  }), 0)]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "1px",
      "width": "100%",
      "font-size": "12px",
      "bottom": "20px"
    }
  }, [(_vm.myhost === 'progati.micromuneem.com' || _vm.myhost === 'bmcf.microfinancesoftware.in') ? _c('thead', [_vm._m(31), _vm._v(" "), _vm._m(32), _vm._v(" "), _vm._m(33)]) : _c('thead', [_vm._m(34), _vm._v(" "), _vm._m(35), _vm._v(" "), _vm._m(36)])]), _vm._v(" "), (_vm.myhost === 'progati.micromuneem.com' || _vm.myhost === 'bmcf.microfinancesoftware.in') ? _c('div', [_c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _vm._m(37), _vm._v(" "), _c('p', [_vm._v("1. কোম্পানির অপারেটিভ অ্যাকাউন্ট ধারণকারী অন্যান্য সদস্যদের সুদের সাথে ঋণ দেওয়া হয়।")]), _vm._v(" "), _c('p', [_vm._v("2. সমস্ত ঋণ মাসিক/সাপ্তাহিক/দৈনিক কিস্তিতে ঋণগ্রহীতার আয়/ পরিশোধের ক্ষমতার উপর নির্ভর করে কিন্তু কোম্পানি কর্তৃক প্রদত্ত সর্বোচ্চ সময়ের মধ্যে পরিশোধযোগ্য।")]), _vm._v(" "), _c('p', [_vm._v("3. একজন আবেদনকারীকে সময়ে সময়ে কোম্পানির দ্বারা নির্ধারিত শেয়ারের ধারক হতে হবে।")]), _vm._v(" "), _c('p', [_vm._v("4. জামিনকে অবশ্যই সক্রিয় অ্যাকাউন্টের সাথে কোম্পানির সদস্য হতে হবে। ব্যক্তিগত জামিন/এসএইচজি স্কিম/যৌথ দায় পরিকল্পনার বিপরীতে ঋণের জন্য দুই বা তার বেশি জামিনের প্রয়োজন হবে। একজন ব্যক্তি একবারে একাধিক ঋণের জন্য জামিন থাকতে পারে না। তদুপরি, ইতিমধ্যে কোম্পানির ঋণে থাকা সদস্যরা জামিন/গ্যারান্টি থাকতে পারে না।")]), _vm._v(" "), _c('p', [_vm._v("5. ঋণ মঞ্জুর করা হবে শুধুমাত্র যদি কোম্পানী আবেদনকারীর দ্বারা প্রদত্ত তথ্য এবং সেইসঙ্গে আবেদনকারীর অতীত রেকর্ড এবং জামিনের বিষয়ে সন্তুষ্ট হয়।")]), _vm._v(" "), _c('p', [_vm._v("6. কোম্পানী ঋণের আবেদন প্রত্যাখ্যান করার জন্য বা বর্ধিত জামিন বা জামিন বাতিল করার কারণ জানাতে বাধ্য থাকবে না।")]), _vm._v(" "), _c('p', [_vm._v("7. কোম্পানির ঋণ অনুমোদনকারী কমিটি কর্তৃক একটি ঋণ মঞ্জুর করা সত্ত্বেও I সেক্রেটারি বা মহাব্যবস্থাপক অগ্রিম আটকে রাখার কারণে। কোম্পানি তার বিবেচনার ভিত্তিতে অনুমোদন প্রত্যাহার করার অধিকার সংরক্ষণ করে এবং প্রয়োজন হবে না, বা এর জন্য কোনো কারণ বরাদ্দ করার আহ্বান জানানো হবে না।")]), _vm._v(" "), _c('p', [_vm._v("8. মাসিক সাত দিন বিলম্ব, সাপ্তাহিক এক সপ্তাহ বিলম্ব, দৈনিক কিস্তিতে একদিন বিলম্ব ঋণকে ওভারডিউ লোনে রূপান্তরিত করবে এবং একটি নোটিশ করতে পারে যার জন্য Rs. প্রতিটি নোটিশের জন্য ঋণগ্রহীতার কাছ থেকে 100/- চার্জ করা হবে।")]), _vm._v(" "), _c('p', [_vm._v("9. কোম্পানির মতে, যে উদ্দেশ্যে এটি নেওয়া হয়েছিল তার জন্য এটি প্রয়োগ করা না হলে ঋণ অবিলম্বে ফেরত নেওয়া হবে৷ এই বিষয়ে কোম্পানির সিদ্ধান্ত চূড়ান্ত এবং চূড়ান্ত এবং ঋণগ্রহীতা বা জামিনদারদের দ্বারা প্রশ্নে বলা দায়বদ্ধ নয়।")]), _vm._v(" "), _c('p', [_vm._v("10. কোনো ঋণগ্রহীতার দুই মাসের জন্য ক্রমাগত খেলাপি হলে, কোম্পানি ঋণগ্রহীতা বা জামিনদারদের নিয়োগকর্তাদের কাছে যাওয়ার অধিকার সংরক্ষণ করে এবং/অথবা তাদের সদস্যদের তথ্যের জন্য তাদের নাম প্রকাশ করে। অধিকন্তু এটি আইনী পদ্ধতিতে ঋণ পুনরুদ্ধারের জন্য উপযুক্ত কর্তৃপক্ষের কাছেও যেতে পারে।")]), _vm._v(" "), _c('p', [_vm._v("11. যদি কোন কারণে ঋণগ্রহীতা নির্ধারিত তারিখে সম্মত কিস্তি পরিশোধ করতে না পারেন তবে তাকে যতটা সম্ভব পরিশোধ করতে হবে (যদিও তা ছোটই হতে পারে) এবং কিস্তি হ্রাস বা সময় বাড়ানোর জন্য লিখিতভাবে আবেদন করতে হবে। তার/তার জামিনের লিখিত সম্মতির মধ্যে সেখানে তার/তার পরিস্থিতির বিশদ বিবরণ দেয় যে কেন সে সম্মত মাসিক কিস্তি, সাপ্তাহিক কিস্তি, দৈনিক কিস্তি পরিশোধ করতে অক্ষম।")]), _vm._v(" "), _c('p', [_vm._v("12. কোম্পানী কোন সূচনা দিতে বাধ্য নয় এবং কোন সূচনা বা নোটিশ না প্রাপ্তি ঋণগ্রহীতার দ্বারা কিস্তি পরিশোধের ক্ষেত্রে জামানত ফর্ম দ্বারা একটি অজুহাত হিসাবে অঙ্গীকার করা যাবে না। ঋণগ্রহীতা নির্ধারিত তারিখে সম্মত মাসিক কিস্তি, সাপ্তাহিক কিস্তি, দৈনিক কিস্তি পরিশোধ করে তা দেখা জামিনের কর্তব্য; এবং ঋণ গ্রহীতা কর্তৃক ডিফল্ট বা কিস্তি পরিশোধে ঋণগ্রহীতার অক্ষমতা বা ব্যর্থতার ক্ষেত্রে, জামিনকে অবশ্যই পরবর্তী মাসের নির্ধারিত তারিখের আগে তা পরিশোধ করতে হবে। একজন সদস্যের অন্যের কাছে জামিন হওয়া উচিত, শুধুমাত্র যদি সে চিনতে পারে এবং তার জামিনের দায়িত্ব পালন করতে পারে। এটি স্পষ্টভাবে বোঝা উচিত যে প্রতিটি জামিন ঋণের সম্পূর্ণ পরিমাণের জন্য দায়ী (পরিষেবা এবং অন্যান্য চার্জ সহ) এবং অনুপাতে নয়।")]), _vm._v(" "), _c('p', [_vm._v("13. ঋণগ্রহীতা এবং জামিনদাররা একজন কর্মকর্তার সামনে কোম্পানিতে ব্যক্তিগতভাবে নিজেদের উপস্থাপনের মাধ্যমে ঋণ বন্ড এবং সংশ্লিষ্ট অন্যান্য নথিপত্র সম্পাদন করবে।")]), _vm._v(" "), _c('p', [_vm._v("14. কোম্পানির প্রশাসনিক ও চলমান ব্যয় পুনরুদ্ধারের জন্য সময়ে সময়ে ব্যবস্থাপনা কমিটি কর্তৃক নির্ধারিত ঋণের উপর কোম্পানি একটি সার্ভিস চার্জ ধার্য করবে।")]), _vm._v(" "), _c('p', [_vm._v("15. ঋণগ্রহীতা এবং জামিনদাররা তাদের ঠিকানা বা যোগাযোগ নম্বরে কোনো পরিবর্তনের ক্ষেত্রে তিন দিনের মধ্যে অফিসকে জানাতে বাধ্য।")]), _vm._v(" "), _c('p', [_vm._v("16. উপরের সমস্ত পক্ষগুলি নিম্নলিখিত সমস্ত শর্তাবলীতে সম্মত যে ঋণগ্রহীতা ক্ষুদ্রঋণের নিয়ম অনুযায়ী এই পরিমাণ ব্যবহার করবেন এবং এই পরিমাণ বা এর কোনো অংশ অন্য কোনো উদ্দেশ্যে ব্যবহার করবেন না। আমরা এও সম্মতি দিচ্ছি যে যদি কোম্পানি ব্যাখ্যা করার কোনো কারণ খুঁজে পায় যা মেনে করা হয়নি, তাহলে কোম্পানির এই ঋণের পরিমাণ বা এর কিছু অংশ প্রত্যাহার করার অধিকার আছে কোনো ছাড় ছাড়াই।")]), _vm._v(" "), _c('p', [_vm._v("17. আমি এবং আমার জামিনদার অতীতে কোন অবৈধ কাজের সাথে জড়িত নই এবং আমাদের বিরুদ্ধে কোন আদালতে কোন ফৌজদারি মামলা বিচারাধীন নেই বা কোন থানায় কোন এফআইআর নথিভুক্ত করা হয়নি।")]), _vm._v(" "), _c('p', [_vm._v("18. আমি/আমাদের উপর কোন আর্থিক প্রতিষ্ঠান, ব্যাঙ্ক ফাইন্যান্স কোম্পানী থেকে কোন প্রকার ঋণের বোঝা নেই, বা কোন আর্থিক প্রতিষ্ঠান, ব্যাঙ্ক বা ফাইন্যান্স কোম্পানী থেকে আমাকে/আমাদের খেলাপি হিসাবে ঘোষণা করা হয়নি।")]), _vm._v(" "), _c('p', [_vm._v("19. আমি/আমরা উল্লিখিত ঋণের সম্পূর্ণ কিস্তি পরিশোধ করতে সম্পূর্ণরূপে সক্ষম এবং আমি/আমরা কোনো অবস্থাতেই অর্থপ্রদানে বিলম্ব করব না")]), _vm._v(" "), _c('p', [_vm._v("20. কোম্পানীর যে কোন কর্মচারী কিস্তির টাকা আদায় করতে আসবেন, আমি তাদের সাথে ভদ্র আচরন রাখব এবং তাকে কোন প্রকার আপত্তিকর কথা বলবো না, কোন প্রকার ক্ষতি বা মারধর করার চেষ্টা করব না এবং নোংরামি করব না। তার বিরুদ্ধে. আচরণ বা গালিগালাজের অভিযোগ করবে না যদি আমাদের দ্বারা কোনো আপত্তিজনক আচরণ করা হয় তাহলে কোম্পানি আমাদের বিরুদ্ধে আইনি ব্যবস্থা নিতে স্বাধীন থাকবে।")]), _vm._v(" "), _c('p', [_vm._v("21. আমি/আমরা নোটিশ, অনুস্মারক এবং ইলেকট্রনিক তথ্য ফোন ইত্যাদি দেওয়ার জন্য কোম্পানি দায়ী থাকব না। ঋণ পরিশোধের নির্ধারিত তারিখের সূচনা সংক্রান্ত আমার কিস্তির সম্পূর্ণ অর্থ প্রদানের জন্য, এর সাথে সম্পর্কিত সম্পূর্ণ দায়িত্ব আমার/আমাদের. ")]), _vm._v(" "), _c('p', [_vm._v("22. যদি ঋণগ্রহীতা (গণ) বা গ্যারান্টার (রা) তাদের ব্যবসা, চাকরি, বাসস্থান, মোবাইল নম্বর বা ইমেল আইডি পরিবর্তন করেন, তাহলে তারা কোম্পানিকে পূর্বে লিখিত নোটিশ দেবেন।")]), _vm._v(" "), _c('p', [_vm._v("23. যে আমি/আমরা একটি বিবৃতি দেওয়ার প্রতিশ্রুতি দিচ্ছি যে যদি ভবিষ্যতে আমাদের দ্বারা কিস্তিগুলি ভবিষ্যতে চেকের মাধ্যমে পরিশোধ করা হয়, তাহলে আমরা ব্যাঙ্কে দেওয়া চেকের অর্থপ্রদান বন্ধ করব না বা ক্ষতির রিপোর্ট করব না উল্লিখিত চেক থানায়। আমরা সেই অ্যাকাউন্টটি বন্ধ করব না, যদি আমরা তা করি তবে কোম্পানির আমাদের বিরুদ্ধে আইনি ব্যবস্থা নেওয়ার অধিকার থাকবে।")]), _vm._v(" "), _c('p', [_vm._v("24. এটি কোম্পানির স্টোরেজ সম্পর্কিত সুবিধার সময় যেমন S.M.S. আমরা কলিং, ইমেল বিজ্ঞপ্তি প্রদানের জন্য প্রয়োজনীয় অতিরিক্ত পরিষেবা চার্জ প্রদান করব।")]), _vm._v(" "), _c('p', [_vm._v("25. এই চুক্তি অনুসারে গ্যারান্টার সম্পূর্ণরূপে দায়ী এবং দায়বদ্ধ, যদি কোনও গুরুতর অসুস্থতা দে খা দেয় বা কোনও সদস্য কিস্তি দিতেj অক্ষম হয় বা আবেদনের ভবিষ্যতে কোনও ধরণেরn খেলাপি হয়, তবে সম্পূর্ণ ঋণ গ্যারান্টার এবং গ্রুপ সদস্যদের দ্বারা পরিশোধ করা হবে। শেষ  কিস্তির আগে। ")]), _vm._v(" "), _c('p', [_vm._v("26. আমি/আমাদের দ্বারা কোম্পানীকে দেওয়া সমস্ত তথ্য মৌখিকভাবে প্রদান করা হয়েছে যা সত্য এবং সঠিক যাতে কোন প্রকারের কোন মিথ্যা তথ্য বলা হয়নি, যদি কোন তথ্য মিথ্যা বলে প্রমাণিত হয় তবে কোম্পানির অধিকার রয়েছে আমাদের বিরুদ্ধে আইনি ব্যবস্থা নিতে। আমি ঋণ সংক্রান্ত যাবতীয় তথ্য, যেমন সুদের পরিমাণ সংরক্ষণ করব। কিস্তি, কিস্তির সময় এবং পরিশোধের সময়। কোম্পানির কর্মচারীর দ্বারা আমাকে সম্পূর্ণ তথ্য দেওয়া হয়েছে, আমরা উপরের সমস্ত শর্তাবলীর জন্য সম্পূর্ণরূপে প্রস্তুত এবং যদি আমি/আমরা কিস্তি পরিশোধে দেরি করি, তাহলে ভবিষ্যতে আইনগত ব্যয় এবং অন্যান্য খরচের অতিরিক্ত বোঝা চাপা হবে। আমাদের দ্বারা প্রদত্ত।")]), _vm._v(" "), _c('p', [_vm._v("27. আমার/আমাদের দ্বারা জমা দেওয়া সমস্ত নথি যেমন আধার কার্ড, প্যান কার্ড, রেশন কার্ড, ড্রাইভিং লাইসেন্স, ব্যাঙ্কের পাসবুক এবং ছবির সাথে কোনও কারসাজি করা হয়নি বা ভবিষ্যতে আমাদের দ্বারা কোনও জাল নথি জমা দেওয়া হয়েছে, যদি কোনও নথি জাল পাওয়া গেছে, কোম্পানির দ্বারা আমাদের বিরুদ্ধে 420 মামলা করা যেতে পারে, যা আমরা ইতিমধ্যেই অবগত।")]), _vm._v(" "), _c('p', [_vm._v("28. আমি/আমরা উল্লিখিত তারিখের প্রতি 15 দিনে আমাদের কিস্তি পরিশোধ করতে চাই।")]), _vm._v(" "), _c('p', [_vm._v("29. এই ঋণ পরিশোধের জন্য এবং বকেয়া বা এর কোনো অংশ গ্রহণের জন্য বা অন্য কোনো নির্দিষ্ট উদ্দেশ্যে কোম্পানীর দ্বারা ডাকা হলে আমি/আমরা যথাসময়ে উপস্থিত থাকব।")]), _vm._v(" "), _c('p', [_vm._v("30. আমার বার্ষিক আয় 500000/--এর কম, উক্ত চুক্তি বা ঋণ করার সময় আমরা কোন প্রকার নেশা করিনি, আমরা সম্পূর্ণ সচেতনতার সাথে এই চুক্তিটি করছি।")]), _vm._v(" "), _c('p', [_vm._v("31.আবেদনকারী  সহ-আবেদনকারীর বা জামিনদারের স্বাভাবিক বা দুর্ঘটনাজনিত মৃত্যু হলে কোন কিস্তি দিতে হবে না, তবে মৃত্যুর শংসাপত্র জমা দেওয়ার ১৫ দিন পর থেকে।")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(38), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _vm._m(39), _vm._v(" "), _c('p', [_vm._v("1. Loans are granted with interest of other members who hold operative account with company.")]), _vm._v(" "), _c('p', [_vm._v("2. All loans are repayable by monthly /weekly /daily installments depending upon the income / repayment capacity of the borrower but within a maximum period granted by the company.")]), _vm._v(" "), _c('p', [_vm._v("3. An Applicant should be a holder of shares as prescribed by the company from time to time.")]), _vm._v(" "), _c('p', [_vm._v("4. Sureties must also be member of the company with holding active account. Two or more sureties will be required for loans against personal sureties / SHG scheme / Joint liability scheme. A person cannot stand surety for more than one loan at a time. Moreover members already in debt of the company cannot stand surety / Guarantee.")]), _vm._v(" "), _c('p', [_vm._v("5. Loans will only be sanctioned if the company is satisfied about the information furnished by the applicant as well as sureties along with past record of the applicant and sureties.")]), _vm._v(" "), _c('p', [_vm._v("6. The company shall not be bound to give the reason for refusing a loan application or for disapproving the extended surety or sureties.")]), _vm._v(" "), _c('p', [_vm._v("7. Notwithstanding that a loan has been sanctioned by company's loan approving committee I Secretary or General Manager may for reason with hold the advance. The company reserves the right of revoking the sanction at its discretion and shall not be required, or called upon to assign any reason for the same.")]), _vm._v(" "), _c('p', [_vm._v("8. Seven days delay in monthly, one week delay in weekly, one day delay in daily installment will convert the loan into overdue loan and may attract a notice for which Rs. 100/- will be charged from the Loanee for each notice.")]), _vm._v(" "), _c('p', [_vm._v("9. Loan is liable to be recalled immediately if in the opinion of the company, it is not applied for the purpose it was taken. The company's decision in this regard being final and conclusive and not liable to be called in the question by the borrower or the sureties.")]), _vm._v(" "), _c('p', [_vm._v("10. In case of persistent default for two months by any borrower, the company reserves the right of approaching the employers of the borrowers or sureties and / or publishes their names for the information of their members. Moreover it may also approach appropriate authority(s) for recovering the loan in legal manner.")]), _vm._v(" "), _c('p', [_vm._v("11. If for any reason the borrower is unable to repay the agreed installments on the due date he / she should pay as much as possibly can (however small it may be) and should also apply in writing for reduction of installments or extension of time within written consent of his/ her sureties giving there in details of his / her circumstances why he / she is unable to repay the agreed monthly installment, weekly installment, daily installment.")]), _vm._v(" "), _c('p', [_vm._v("12. The company is not bound to give any intimation and non receipt of any intimation or notice cannot be pledged as an excuse by the surety form on payment of installment by the borrower. it is the duty of the surety to see that the borrower pays agreed monthly installment, weekly installment, daily installment on the due date; and incase of default by the borrower or inability or failure of the borrower to pay installment, the surety must pay it before next month's due date thereon forthwith. A member should stand surety to another, only if he recognize and can fulfill his / her duty of a surety. It should be clearly understood that every surety is responsible for the full amount of the loan (including service and other charges if any) and not in proportion.")]), _vm._v(" "), _c('p', [_vm._v("13. The borrower and the sureties shall execute the loan bond and other documentation relating to by presenting themselves personally at the company before one of the officers.")]), _vm._v(" "), _c('p', [_vm._v("14. The company shall levy a service charge on loans decided by the managing committee from time to time for recovering the administrative and running expenses of the company.")]), _vm._v(" "), _c('p', [_vm._v("15. The borrowers and sureties are bound to inform the office within three days in case of any changes in their address or contact numbers.")]), _vm._v(" "), _c('p', [_vm._v("16. All the above parties agree on all the following terms and condition that the borrower will use this amount as per the rules of microfinance and will not use this amount or any part of it for any other purpose. We also agree that if the company finds any reason to explain which has not been complied with, the company has the right to withdraw this loan amount or part thereof without any Will withdraw the concession.")]), _vm._v(" "), _c('p', [_vm._v("17. I and my guarantor are not involved in any illegal act in the past and neither a criminal case is pending against us in any court nor any FIR is registered in any police station.")]), _vm._v(" "), _c('p', [_vm._v("18. That I/We are not burdened with any kind of loan from any financial institution, bank finance company, nor have I/we been declared a defaulter from any financial institution, bank or finance company.")]), _vm._v(" "), _c('p', [_vm._v("19. That I/we are fully capable of paying the entire instalments of the said loan and I/We shall not delay the payment under any circumstances")]), _vm._v(" "), _c('p', [_vm._v("20. That whichever employee of the company will come to collect the instalment amount, I will keep polite behaviour with them and will not call him any kind of objectionable thing, will not try to harm or beat him in any way nor will he be dirty against him. Will not allege behaviour or abusive language If any abusive behaviour is done by us then company will be free to take legal action against us.")]), _vm._v(" "), _c('p', [_vm._v("21. That I/We the company will not be responsible for giving notices, reminders and electronic information phone etc. For the full payment of my instalments related to intimation of the due date of payment of the loan, the entire responsibility related to this will be my / ours.")]), _vm._v(" "), _c('p', [_vm._v("22. That if the Borrower (s) or the Guarantor (s) change their business, job, Domicile , Mobile number or email Id, they shall give prior written notice to the company.")]), _vm._v(" "), _c('p', [_vm._v("23. That I / We undertake to make a statement that if the instalments are paid by us in future through are paid by us in future through cheque, then we will not make stop payment of the checks given in the bank nor report the loss of the said check to the police station. Nor will we close that account, if we do so, the company will have the right to take legal action against us.")]), _vm._v(" "), _c('p', [_vm._v("24. This is during the Company’s storage related facilities Such as S.M.S. we will provide the additional service charge required for providing the calling, email notice.")]), _vm._v(" "), _c('p', [_vm._v("25. That the guarantor is fully responsible and liable as per this agreement, if any serious illness occurs Or any members unable to pay installment Or any kind of default with the application future, the entire loan shall be paid by the guarantor & group members within the due date. ")]), _vm._v(" "), _c('p', [_vm._v("26. That all the information given by me/us to the company has been provided orally which is the true and correct in which no false fact of any kind have been told , if any information is found to be false then the company has the right to take legal action against us. I will keep all the information about the loan, Such as the amount of interest. Instalment, the time of instalment and the time of repayment. I have been given complete information by the company employee, we are fully prepared for all the above terms and condition and if me/we delay in paying the instalment, then the additional burden of legal expanses and other expenses which will come in future will be provided by us.")]), _vm._v(" "), _c('p', [_vm._v("27. That all the documents submitted by me/us Such as Aadhar card, Pan card , Ration card, Driving license, Bank Passbook and Photo have not been tampered with or any fake document has been submitted by us near in future, if any document is found to be forged, we can be sued for 420 by the company, which we are already aware of.")]), _vm._v(" "), _c('p', [_vm._v("28. That me/we want to pay our instalments every 15 days of said dated. ")]), _vm._v(" "), _c('p', [_vm._v("29. That I/we shall be present in time as and when called for by the company for the payment of this loan and acceptance of the arrears or any part thereof or for any other specified purpose.")]), _vm._v(" "), _c('p', [_vm._v("30. That my annual income is less than 500000/-, we have not done any kind of intoxication while doing the said agreement or loan, we are doing this agreement in full consciousness.")]), _vm._v(" "), _c('p', [_vm._v("31. No installments have to paid if any normal Or accidental death of Applicant Or Co-applicant/Surety after 15 days of submit his/her death certificate.")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(40)]) : _c('div', [_c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _vm._m(41), _vm._v(" "), _c('p', [_vm._v("1. उपरोक्त सभी पक्ष निम्नलिखित सभी शर्ते व नियम पर अपनी सहमति व्यक्त करते हैं यह है कि ऋण धारी इस राशि का उपयोग माइक्रोफाइनेंस की नियमावली समझकर करेंगे तथा इस राशि या इसके किसी भी अंश का उपयोग अन्य किसी भी उद्देश्य की पूर्ति हेतु नहीं करेंगे जिसके लिए इसे स्वीकृत नहीं किया गया है हम इसके लिए भी सहमति व्यक्त करते हैं कि यदि कंपनी को सबसे कोई कारण मिलता है जो स्पष्ट करता है कि सर्च की पालना नहीं की गई है तो कंपनी को अधिकार है कि वह इस ऋण राशि या उसके अंश को बिना किसी रियायत के वापस ले लेंगे")]), _vm._v(" "), _c('p', [_vm._v("2. मैं /हम लोन के लिए आवेदन करने वाले तथा गारंटर पूर्व में किसी भी गैर कानूनी कार्य में लिप्त नहीं है और ना ही किसी न्यायालय में हमारे विरुद्ध आपराधिक मामला विचाराधीन है और ना ही किसी भी थाने में कोई एफ आई आर दर्ज है।")]), _vm._v(" "), _c('p', [_vm._v("3. यह है कि मैं / हमें किसी वित्तीय संस्थान, बैंक या फाइनेंस कंपनी से मुझे / हमको डिफॉल्टर घोषित नहीं किया गया है।")]), _vm._v(" "), _c('p', [_vm._v("4. यह है कि मैं हम उक्त लोन की संपूर्ण किस्तों का भुगतान करने में पूरी तरह से सक्षम है और किसी भी विपरीत परिस्थिति में मैं हम भुगतान करने में देरी नहीं करेंगे।")]), _vm._v(" "), _c('p', [_vm._v("5. यह है कि कंपनी का जो भी कर्मचारी किस्त की राशि का कलेक्शन करने आएगा मैं उसके साथ विनम्र व्यवहार रखूंगा  रखेंगे एवं उसे किसी भी प्रकार की आपत्तिजनक बात ना कहेंगे किसी भी प्रकार का उसको नुकसान या मारपीट की कोशिश नहीं करेंगे और ना ही उसके खिलाफ गंदे व्यवहार या अपशब्द बोलने आरोप नहीं लगाएंगे अगर हमारे द्वारा कोई भी अभद्र व्यवहार किया जाता है तो कंपनी कर्मचारी तथा कंपनी हमारे प्रति कानूनी कार्रवाई करने के लिए स्वतंत्र होंगे")]), _vm._v(" "), _c('p', [_vm._v("6. यह है कि मैं हम नियत तिथि की सूचना देने से संबंधित जानकारी अपनी किस्तों के संपूर्ण भुगतान के लिए नोटिस रिमाइंडर व इलेक्ट्रॉनिक सूचना फोन इत्यादि करने के लिए कंपनी जिम्मेदार नहीं होगी इस बात की याददाश्त संबंधित संपूर्ण जिम्मेदारी मेरी या  हमारी होगी")]), _vm._v(" "), _c('p', [_vm._v("7. यह है कि अगर ऋणी या गारंटर अपने व्यवसाय नौकरी मूल निवास मोबाइल नंबर या ईमेल आईडी का परिवर्तन करता है तो इस बात की सूचना कंपनी को पूर्व में लिखित प्रदान करेंगे")]), _vm._v(" "), _c('p', [_vm._v("8. यह है कि मैं /हम यह वचनबद्ध बयान करते हैं कि भविष्य में यदि हमारे द्वारा किस्तों का भुगतान चेक के माध्यम से किया जाता है तो हम दिए गए चेकों को बैंक में स्टॉप नहीं कराएंगे और ना ही उक्त चेक के खोने की रिपोर्ट दर्ज थाने में कराएंगे और ना ही उक्त खाते को बंद कर आएंगे यदि हम ऐसा करते हैं तो कंपनी हमारे विरुद्ध कानूनी कार्रवाई करने का अधिकार रखेगी !")]), _vm._v(" "), _c('p', [_vm._v("9. यह है कि कंपनी द्वारा के संग्रहण संबंधित जो सुविधाएं जैसे कि s.m.s. कॉलिंग मेल किया नोटिस प्रदान करने के लिए जो भी सर्विस चार्ज अलग से मांगेंगे वह हम प्रदान करेंगे|")]), _vm._v(" "), _c('p', [_vm._v("10. यह है कि इस अनुबंध के अनुसार गारंटर की पूरी जिम्मेदारी और उत्तरदायित्व  है अगर भविष्य में आवेदक के साथ  कोई आकस्मिक घटना मृत्यु या दिवालिया या गंभीर बीमारी हो जाती है तो संपूर्ण लोन का भुगतान गारंटर द्वारा किया जाएगा")]), _vm._v(" "), _c('p', [_vm._v("11. यह है कि हम मैं द्वारा कंपनी को दी गई संपूर्ण जानकारी मौखिक प्रदान की गई है जो कि सत्य व सही है जिसमें किसी भी प्रकार का कोई भी झूठा तथ्य नहीं बताया गया है यदि कोई जानकारी झूठी पाई जाती है तो कंपनी हमारे विरोध कानूनी कार्रवाई करने का अधिकार रखेगी मैं हम ने लोन के बारे में समस्त जानकारी जैसे ब्याज कथा किस्तों की राशि किस्तों का समय और अदायगी का समय अच्छी तरह से समझ लिया है कंपनी कर्मचारी द्वारा मुझे संपूर्ण जानकारी दे दी गई है उक्त सभी नियमों व शर्तों के लिए मैं हम पूरी तरह तैयार है और अगर मैं हम किस्त देने में देरी करते हैं तो उस पर लगने वाला अतिरिक्त भार लीगल खर्चा पेपर खर्चा विजिट खर्चा व अन्य खर्च जो भी भविष्य में आएगा वह हमारे द्वारा प्रदान किया जाएगा | ")]), _vm._v(" "), _c('p', [_vm._v("12. यह है कि मैं हम प्रस्तुत किए गए समस्त दस्तावेज जैसे कि आधार कार्ड पैन कार्ड राशन कार्ड ड्राइविंग लाइसेंस बैंक की पासबुक व फोटो के साथ किसी भी तरह की छेड़छाड़ या कोई भी फर्जी दस्तावेज हमारे द्वारा प्रस्तुत नहीं किया गया है निकट भविष्य में अगर किसी भी दस्तावेज के फर्जी पाए जाने पर हमारे खिलाफ 420 ई का मुकदमा कंपनी द्वारा किया जा सकता है किस बात से हम पहले से जानकार हैं | ")]), _vm._v(" "), _c('p', [_vm._v("13. यह है कि हम मैं अपनी किस्तों का भुगतान साप्ताहिक रूप में करना चाहता हूं | ")]), _vm._v(" "), _c('p', [_vm._v("14. यह है कि इस ऋण के भुगतान और उसके बकाया या किसी भी अंश की स्वीकृति या किसी भी अन्य विशिष्ट कार्य हेतु जब भी कंपनी द्वारा बुलाया जाएगा मैं हम समय पर उपस्थित हो जाएंगे | ")]), _vm._v(" "), _c('p', [_vm._v("15. यह है कि मेरी सालाना आय ₹500000 से कम है उक्त एग्रीमेंट या लोन को करते समय हमने किसी भी प्रकार का कोई नशा नहीं किया हुआ है हम पूरे होशो हवास में यह एग्रीमेंट कर रहे हैं | ")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(42), _vm._v(" "), _c('p', {
    staticStyle: {
      "page-break-before": "always"
    }
  }), _vm._v(" "), _vm._m(43), _vm._v(" "), _c('p', [_vm._v("1. All the above parties agree on all the following terms and condition that the borrower will use this amount as\n                      per the rules of microfinance and will not use this amount or any part of it for any other purpose. We also agree\n                      that if the company finds any reason to explain which has not been complied with, the company has the right to\n                      withdraw this loan amount or part thereof without any Will withdraw the concession.")]), _vm._v(" "), _c('p', [_vm._v("2. I and my guarantor are not involved in any illegal act in the past and neither a criminal case is pending against\n                      us in any court nor any FIR is registered in any police station.")]), _vm._v(" "), _c('p', [_vm._v("3. That I/We are not burdened with any kind of loan from any financial institution, bank finance company, nor\n                      have I/we been declared a defaulter from any financial institution, bank or finance company.")]), _vm._v(" "), _c('p', [_vm._v("4. That I/we are fully capable of paying the entire instalments of the said loan and I/We shall not delay the\n                      payment under any circumstances")]), _vm._v(" "), _c('p', [_vm._v("5. That whichever employee of the company will come to collect the instalment amount, I will keep polite\n                      behaviour with them and will not call him any kind of objectionable thing, will not try to harm or beat him in any\n                      way nor will he be dirty against him. Will not allege behaviour or abusive language If any abusive behaviour is\n                      done by us then company will be free to take legal action against us.")]), _vm._v(" "), _c('p', [_vm._v("6. That I/We the company will not be responsible for giving notices, reminders and electronic information\n                      phone etc. For the full payment of my instalments related to intimation of the due date of payment of the loan,\n                      the entire responsibility related to this will be my / ours.")]), _vm._v(" "), _c('p', [_vm._v("7. That if the Borrower (s) or the Guarantor (s) change their business, job, Domicile , Mobile number or email\n                      Id, they shall give prior written notice to the company.")]), _vm._v(" "), _c('p', [_vm._v("8. That I / We undertake to make a statement that if the instalments are paid by us in future through are paid by\n                      us in future through cheque, then we will not make stop payment of the checks given in the bank nor report the\n                      loss of the said check to the police station. Nor will we close that account, if we do so, the company will have the\n                      right to take legal action against us.")]), _vm._v(" "), _c('p', [_vm._v("9. This is during the Company’s storage related facilities Such as S.M.S. we will provide the additional service\n                      charge required for providing the calling, email notice.")]), _vm._v(" "), _c('p', [_vm._v("10. That the guarantor is fully responsible and liable as per this agreement, if any accidental event ,death or\n                      insolvency or serious illness occurs with the application future, the entire loan shall be paid by the guarantor.")]), _vm._v(" "), _c('p', [_vm._v("11. That all the information given by me/us to the company has been provided orally which is the true and\n                      correct in which no false fact of any kind have been told , if any information is found to be false then the\n                      company has the right to take legal action against us. I will keep all the information about the loan, Such as the\n                      amount of interest. Instalment, the time of instalment and the time of repayment. I have been given complete\n                      information by the company employee, we are fully prepared for all the above terms and condition and if\n                      me/we delay in paying the instalment, then the additional burden of legal expanses and other expenses which\n                      will come in future will be provided by us.")]), _vm._v(" "), _c('p', [_vm._v("12. That all the documents submitted by me/us Such as Aadhar card, Pan card , Ration card, Driving license,\n                      Bank Passbook and Photo have not been tampered with or any fake document has been submitted by us near in\n                      future, if any document is found to be forged, we can be sued for 420 by the company, which we are already\n                      aware of.")]), _vm._v(" "), _c('p', [_vm._v("13. That me/we want to pay our instalments monthly.")]), _vm._v(" "), _c('p', [_vm._v("14. That I/we shall be present in time as and when called for by the company for the payment of this loan and\n                      acceptance of the arrears or any part thereof or for any other specified purpose. ")]), _vm._v(" "), _c('p', [_vm._v("15. That my annual income is less than 500000/-, we have not done any kind of intoxication while doing the said\n                      agreement or loan, we are doing this agreement in full consciousness.")]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(44)]), _vm._v(" "), _c('br'), _c('br'), _c('br'), _c('br'), _c('br')]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.status == 'pending') ? _c('div', [_c('br'), _c('br'), _vm._v(" "), _c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', [_c('th', [_vm._v("Application Date")]), _vm._v(" "), _c('th', [_vm._v("Customer")]), _vm._v(" "), _c('th', [_vm._v("Account Number")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Name")]), _vm._v(" "), _c('th', [_vm._v("Loan Amount")]), _vm._v(" "), _c('th', [_vm._v("Paid Amount")]), _vm._v(" "), _c('th', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pl.planType === 'normal'),
      expression: "pl.planType === 'normal'"
    }]
  }, [_vm._v("No. of EMI")])]), _vm._v(" "), _c('tbody', [_c('td', [_vm._v(_vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))]), _vm._v(" "), _c('td', [(_vm.seeRecord.member) ? _c('i', [_vm._v(_vm._s(_vm.seeRecord.member.name) + " (" + _vm._s(_vm.seeRecord.member.code) + ")")]) : _vm._e()]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mem.accountNumber))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mem.guarantorName))]), _vm._v(" "), (_vm.pl.planType === 'normalReduced' || _vm.pl.planType === 'special') ? _c('td', [_vm._v(_vm._s(_vm.pl.amount + _vm.pl.fileCharge + _vm.pl.processingFee))]) : _c('td', [_vm._v(_vm._s(_vm.pl.amount + (_vm.pl.fileCharge) + (_vm.pl.amount * _vm.pl.processingFee) / 100))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.pl.amount))]), _vm._v(" "), _c('td', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.pl.planType === 'normal'),
      expression: "pl.planType === 'normal'"
    }]
  }, [_vm._v(_vm._s(_vm.pl.noOfPayments))])])]), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), (_vm.seeRecord.status == 'pending') ? _c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_vm._m(45)]) : _vm._e(), _vm._v(" "), _c('br'), _c('br')]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _vm._m(46)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintCustomerEMIModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(47), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printCustomerEMI()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printCustomerEMI"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                          "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                          ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.member_loan_plan.applicationNo,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                            Show this if the rendering fails.\n                          ")])], 1)])]), _vm._v(" "), _c('h3', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Loan EMI Card")]), _vm._v(" "), (_vm.seeRecord.status == 'disbursed') ? _c('div', [_c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Branch : " + _vm._s(_vm.seeRecord.branch.name) + " (" + _vm._s(_vm.seeRecord.branch.branchCode) + ")")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Date : " + _vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Customer Name ")]), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.name) + " (" + _vm._s(_vm.seeRecord.member.code) + ")")]), _vm._v(" "), _c('td', [_vm._v("Group Name ")]), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.collection_center.name) + " (" + _vm._s(_vm.seeRecord.collection_center.centerCode) + ")")])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Contact No ")]), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.mobile))]), _vm._v(" "), _c('td', [_vm._v("Spouse Name ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.spouseName))])]), _vm._v(" "), _c('tr', [_vm._m(48), _vm._v(" "), _c('td', [_vm._v("₹ " + _vm._s(_vm.planAmt(_vm.seeRecord)))]), _vm._v(" "), _c('td', [_vm._v("Plan Name ")]), _c('td', [_vm._v(" " + _vm._s(_vm.pl.name) + " ")])]), _vm._v(" "), _c('tr', [_vm._m(49), _c('td', [_vm._v(" " + _vm._s(_vm.pl.noOfPayments))]), _vm._v(" "), _vm._m(50), _c('td', [_vm._v(" ₹ " + _vm._s(_vm.memberFirstEmiRecord))])])])]), _vm._v(" "), _c('h3', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("EMI Schedule Terms ")]), _vm._v(" "), _c('table', {
    staticClass: "table table-condensed",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', [_c('tr', [_vm._m(51), _vm._v(" "), _vm._m(52), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in') ? _c('td', [_c('strong', [_vm._v("Interest")])]) : _vm._e(), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in') ? _c('td', [_c('strong', [_vm._v("Principal")])]) : _vm._e(), _vm._v(" "), _vm._m(53), _vm._v(" "), _vm._m(54), _vm._v(" "), _vm._m(55), _vm._v(" "), _vm._m(56)])]), _vm._v(" "), _c('tbody', _vm._l((_vm.memberEmiRecords), function(memberEmiRecord) {
    return _c('tr', {
      key: memberEmiRecord.id
    }, [_c('td', [_vm._v(_vm._s(memberEmiRecord.emiNo))]), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm._f("myDate")(memberEmiRecord.emiDate)))]), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in') ? _c('td', [_vm._v(_vm._s(memberEmiRecord.intrest))]) : _vm._e(), _vm._v(" "), (_vm.myhost !== 'supergsg.microfinancesoftware.in') ? _c('td', [_vm._v(_vm._s(memberEmiRecord.principal))]) : _vm._e(), _vm._v(" "), _c('td', [_vm._v(_vm._s(memberEmiRecord.total))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td'), _vm._v(" "), _c('td')])
  }), 0)]), _vm._v(" "), _c('br'), _vm._v(" "), _c('br'), _c('br'), _vm._v(" "), _vm._m(57)]) : _vm._e()]) : _vm._e()])])])]), _vm._v(" "), _vm._m(58)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewPrintCustomerModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_vm._m(59), _vm._v(" "), _c('button', {
    staticClass: "float-right btn btn-sm btn-primary",
    on: {
      "click": function($event) {
        return _vm.printCustomer()
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-print"
  }), _vm._v(" Print")])]), _vm._v(" "), _c('div', {
    staticClass: "modal-body",
    attrs: {
      "id": "printCustomer"
    }
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-12"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [(_vm.seeRecord.member) ? _c('div', {
    staticClass: "card-body box-profile"
  }, [_c('table', {
    staticClass: "table table-condensed",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('td', {
    attrs: {
      "width": "18%"
    }
  }, [_c('img', {
    attrs: {
      "src": _vm.logo,
      "height": "90"
    }
  })]), _vm._v(" "), _c('td', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "colspan": "2"
    }
  }, [_c('h4', [_c('strong', [_vm._v(_vm._s(_vm.getCompanyRecord.companyName))]), _vm._v(" "), _c('br'), _vm._v(" "), _c('small', [_vm._v("Address : " + _vm._s(_vm.getCompanyRecord.address) + ", " + _vm._s(_vm.getCompanyRecord.city) + ", " + _vm._s(_vm.getCompanyRecord.state) + " - " + _vm._s(_vm.getCompanyRecord.pin) + "\n                          "), _c('br'), _vm._v("CIN : " + _vm._s(_vm.getCompanyRecord.cin) + ", Website - " + _vm._s(_vm.getCompanyRecord.url) + ", Mobile No - " + _vm._s(_vm.getCompanyRecord.phone) + ", Email ID - " + _vm._s(_vm.getCompanyRecord.email) + "\n                          ")])])]), _vm._v(" "), _c('td', {
    staticClass: "text-right",
    staticStyle: {
      "text-align": "center"
    },
    attrs: {
      "width": "20%"
    }
  }, [_c('barcode', {
    attrs: {
      "value": _vm.seeRecord.member_loan_plan.applicationNo,
      "height": "45",
      "width": "1"
    }
  }, [_vm._v("\n                            Show this if the rendering fails.\n                          ")])], 1)])]), _vm._v(" "), _c('h2', {
    staticClass: "text-center",
    staticStyle: {
      "text-align": "center"
    }
  }, [_vm._v("Loan Sanction Letter")]), _vm._v(" "), (_vm.seeRecord.status == 'disbursed') ? _c('div', [_c('table', {
    staticClass: "table table-condensed",
    attrs: {
      "width": "100%"
    }
  }, [_c('thead', [_c('th', {
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Branch : " + _vm._s(_vm.seeRecord.branch.name) + " (" + _vm._s(_vm.seeRecord.branch.branchCode) + ")")]), _vm._v(" "), _c('th', {
    staticClass: "text-right",
    attrs: {
      "colspan": "2"
    }
  }, [_vm._v("Disbursment Date : " + _vm._s(_vm._f("myDate")(_vm.seeRecord.disbursementDate)))])]), _vm._v(" "), _c('tbody', [_c('tr', [_c('td', [_vm._v("Customer Name ")]), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.name) + "  (" + _vm._s(_vm.seeRecord.member.code) + ")")]), _vm._v(" "), _c('td', [_vm._v("Group Name : " + _vm._s(_vm.seeRecord.collection_center.name) + " (" + _vm._s(_vm.seeRecord.collection_center.centerCode) + ")")]), _vm._v(" "), _vm._m(60)]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Contact No ")]), _c('td', [_vm._v(" " + _vm._s(_vm.seeRecord.member.mobile))]), _vm._v(" "), _c('td', [_vm._v("Gender : " + _vm._s(_vm.mem.gender))])]), _vm._v(" "), _c('tr', [_c('td', [_vm._v("Adhar Number ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.aadharNo))]), _vm._v(" "), _c('td', [_vm._v("Spouse Name  : " + _vm._s(_vm.mem.spouseName))])]), _vm._v(" "), (_vm.mem.fatherName) ? _c('tr', [_c('td', [_vm._v("Father Name (C/O)  ")]), _c('td', [_vm._v(" " + _vm._s(_vm.mem.fatherName))]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  })]) : _vm._e(), _vm._v(" "), _vm._m(61), _vm._v(" "), _c('tr', [_vm._m(62), _c('td', [_vm._v(" " + _vm._s(_vm.mem.address) + ", " + _vm._s(_vm.mem.area))]), _vm._v(" "), _vm._m(63), (_vm.mem.state) ? _c('td', [_vm._v(" " + _vm._s(_vm.mem.district) + ", " + _vm._s(_vm.mem.state.name) + " - " + _vm._s(_vm.mem.pin))]) : _vm._e()]), _vm._v(" "), _vm._m(64), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Bank : ")]), _vm._v(" "), (_vm.mem.bank) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bank.name))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Branch : ")]), (_vm.mem.bankBranch) ? _c('span', [_vm._v(" " + _vm._s(_vm.mem.bankBranch))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Loan ID :")]), _vm._v(" "), (_vm.seeRecord.member_loan_plan) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.member_loan_plan.applicationNo))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Plan Name :")]), _vm._v(" " + _vm._s(_vm.pl.name))])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Account Holder : ")]), _vm._v(_vm._s(_vm.mem.accountHolderName))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("IFSC : ")]), _vm._v(" "), (_vm.mem.ifsc) ? _c('span', [_vm._v(_vm._s(_vm.mem.ifsc))]) : _vm._e()]), _vm._v(" "), (_vm.myhost === 'demo.microfinancesoftware.in') ? _c('td', [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate (%) : " + _vm._s(_vm.pl.rateOfInterest) + "/12 ")]) : _vm._e()]) : _c('td', [(_vm.pl.rateOfInterest > 0) ? _c('strong', [_vm._v("Interest Rate (%) : " + _vm._s(_vm.pl.rateOfInterest) + " ")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("GST Include : ")]), _vm._v(_vm._s(_vm.pl.includeGst))])]), _vm._v(" "), _c('tr', [_vm._m(65), _vm._v(" "), _c('td', [_vm._v(_vm._s(_vm.mem.accountNumber))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Loan Amount :")]), _vm._v(" " + _vm._s(_vm.planAmt(_vm.seeRecord)))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("File Charge : ")]), _vm._v(_vm._s(_vm.fileChargeFee(_vm.seeRecord)))])]), _vm._v(" "), _c('tr', [_vm._m(66), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Processing Fee :")]), _vm._v(" " + _vm._s(_vm.processingFee(_vm.seeRecord)))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Insurance Fee :")]), _vm._v(" " + _vm._s(_vm.insuranceFee(_vm.seeRecord)))])]), _vm._v(" "), (_vm.pl.rateOfInterest) ? _c('tr', [_c('td', [_c('strong', [_vm._v("Income (INR) : ")]), _vm._v(_vm._s(_vm.mem.incomeAmount))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Occupation : ")]), _vm._v(_vm._s(_vm.mem.jobType))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Recovery type :")]), _vm._v(" " + _vm._s(_vm.pl.recoveryType))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Amount to be Paid :")]), _vm._v(" "), (_vm.seeRecord.loanAmount) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.loanAmount))]) : _c('span', [_vm._v(" " + _vm._s(_vm.pl.amount))])])]) : _vm._e(), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Business Name : ")]), _vm._v(_vm._s(_vm.mem.businessName))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Income Type : ")]), _vm._v(_vm._s(_vm.mem.incomeType))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("No of Payments : ")]), _vm._v(" "), (_vm.pl.noOfPayments) ? _c('span', [_vm._v(_vm._s(_vm.pl.noOfPayments))]) : _vm._e()]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Minimum Income : ")]), _vm._v(_vm._s(_vm.mem.minAmount))]), _vm._v(" "), _c('td'), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Purpose : ")]), (_vm.seeRecord.purpose) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.purpose.purpose))]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Description : ")]), _vm._v(_vm._s(_vm.seeRecord.description))])]), _vm._v(" "), _c('tr', [_vm._m(67), _vm._v(" "), _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "120px",
      "height": "140px",
      "float": "right",
      "text-align": "center"
    }
  }, [_c('br'), _c('center', [_vm._v("Guarantor Photo "), _c('br'), _vm._v("with Cross Sign")])], 1)])]), _vm._v(" "), _c('tr', [_vm._m(68), _c('td', [(_vm.seeRecord.guarantor) ? _c('span', [_vm._v(" " + _vm._s(_vm.seeRecord.guarantor.name) + " ( " + _vm._s(_vm.seeRecord.guarantor.code) + " )")]) : _vm._e()]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Contact Number : ")]), (_vm.seeRecord.guarantor) ? _c('span', [_vm._v(_vm._s(_vm.seeRecord.guarantor.mobile) + " ")]) : _vm._e()])]), _vm._v(" "), _c('tr', [_c('td', [_c('strong', [_vm._v("Nominee Name : " + _vm._s(_vm.mem.nomineeName))])]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Nominee Mobile : ")]), _vm._v(_vm._s(_vm.mem.nomineePhone))]), _vm._v(" "), _c('td', [_c('strong', [_vm._v("Nominee Dob : ")]), _vm._v(_vm._s(_vm.mem.nomineeDob))])])])])]) : _vm._e(), _c('br'), _c('br'), _c('br'), _c('br'), _c('br'), _vm._v(" "), _vm._m(69)]) : _vm._e()])])])]), _vm._v(" "), _vm._m(70)])])]), _vm._v(" "), _c('div', {
    staticClass: "modal fade",
    attrs: {
      "id": "viewModal"
    }
  }, [_c('div', {
    staticClass: "modal-dialog modal-lg"
  }, [_c('div', {
    staticClass: "modal-content"
  }, [_vm._m(71), _vm._v(" "), _c('div', {
    staticClass: "modal-body"
  }, [_c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.seeRecord.branch) ? _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.branch.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Branch Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.branch.branchCode))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Agent Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.agent.name))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Agent Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.agent.code))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Plan Details")]), _vm._v(" "), _c('table', {
    staticClass: "table table-sm table-striped table-dark"
  }, [_c('tr', [_c('td', [_c('b', [_vm._v("Plan Name ")]), _vm._v(" : " + _vm._s(_vm.pl.name))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Plan Type ")]), _vm._v(" : " + _vm._s(_vm.pl.planType))])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Type of Interest")]), _vm._v(" : " + _vm._s(_vm.pl.typeOfInterest) + "\n                            ")]), _vm._v(" "), _c('td')]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Recovery Type")]), _vm._v(" : " + _vm._s(_vm.pl.recoveryType) + "\n                            ")]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Number of Payments")]), _vm._v(" :\n                              " + _vm._s(_vm.pl.noOfPayments) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Amount")]), _vm._v(" : " + _vm._s(_vm.pl.amount))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Advance Installment")]), _vm._v(" :\n                              " + _vm._s(_vm.pl.acvanceInstallment) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("Panulty ")]), _vm._v(": " + _vm._s(_vm.pl.panulty))]), _vm._v(" "), _c('td', [_c('b', [_vm._v("Processing Fee ")]), _vm._v(": " + _vm._s(_vm.pl.processingFee) + "\n                            ")])]), _vm._v(" "), _c('tr', [_c('td', [_c('b', [_vm._v("File Charge")]), _vm._v(" : " + _vm._s(_vm.pl.fileCharge))]), _vm._v(" "), (_vm.pl.created_by) ? _c('td', [_c('b', [_vm._v("Created By")]), _vm._v(" : " + _vm._s(_vm.pl.created_by.name) + "\n                            ")]) : _vm._e()])])]), _vm._v(" "), (_vm.seeRecord.member_id) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Member Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.member.name))])]) : _vm._e()]) : _vm._e()])])]), _vm._v(" "), _c('div', {
    staticClass: "col-md-6"
  }, [_c('div', {
    staticClass: "card card-primary card-outline"
  }, [_c('div', {
    staticClass: "card-body box-profile"
  }, [(_vm.seeRecord.branch) ? _c('ul', {
    staticClass: "list-group list-group-unbordered mb-3"
  }, [_c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Plan Type")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.planType))])]), _vm._v(" "), (_vm.seeRecord.collection_center) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Name")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center.name))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center.centerCode))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center_leader) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Leader")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center_leader.name))])]) : _vm._e(), _vm._v(" "), (_vm.seeRecord.collection_center_leader) ? _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Group Leader Code")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.collection_center_leader.code))])]) : _vm._e(), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Disbursement Date")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.disbursementDate))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("EMI Start Date")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.emiStartDate))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Payment Mode")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.paymentMode))])]), _vm._v(" "), _c('li', {
    staticClass: "list-group-item"
  }, [_c('b', [_vm._v("Status")]), _vm._v(" "), _c('a', {
    staticClass: "pull-right"
  }, [_vm._v(_vm._s(_vm.seeRecord.status))])])]) : _vm._e()])])])])]), _vm._v(" "), _vm._m(72)])])]), _vm._v(" "), _c('advancesecurity', {
    attrs: {
      "advanceSecurityRecord": _vm.advanceSecurityRecord,
      "payment_ledgers": _vm.payment_ledgers
    }
  }), _vm._v(" "), _c('printviewdisbursementcollectioncenterwise', {
    attrs: {
      "seeRecords": this.seeRecords,
      "branch": _vm.branch,
      "collectionCenter": _vm.collectionCenter,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo
    }
  }), _vm._v(" "), _c('demandprobeshnarynote', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo,
      "pl": _vm.pl,
      "mem": _vm.mem
    }
  }), _vm._v(" "), _c('aadharagreementletter', {
    attrs: {
      "seeRecord": _vm.seeRecord,
      "getCompanyRecord": _vm.getCompanyRecord,
      "logo": _vm.logo,
      "pl": _vm.pl,
      "mem": _vm.mem
    }
  }), _vm._v(" "), _c('previousloanrecord', {
    attrs: {
      "seeRecord": _vm.seeRecordPrevious,
      "getCompanyRecord": _vm.getCompanyRecord,
      "memberloanplans": _vm.memberloanplans,
      "logo": _vm.logo
    }
  })], 1)])
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "box-header with-border"
  }, [_c('h3', {
    staticClass: "box-title"
  }, [_vm._v("Group Disbursement List")]), _vm._v(" "), _c('div', {
    staticClass: "box-tools"
  })])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', {
    staticStyle: {
      "background-color": "#d6dddd"
    }
  }, [_c('tr', [_c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Sr.")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Application No")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pl Name")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pl Emi Type")]), _vm._v(" "), _c('th', [_vm._v("Plan Amt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Dis Dt")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Emi Start Dt ")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Emi End Dt ")]), _vm._v(" "), _c('th', [_vm._v("Group")]), _vm._v(" "), _c('th', [_vm._v("Member")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Staff")]), _vm._v(" "), _c('th', {
    staticClass: "hidden-xs"
  }, [_vm._v("Pay Mode")]), _vm._v(" "), _c('th', [_vm._v("Action")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "btn btn-flat btn-xs dropdown-toggle",
    attrs: {
      "type": "button",
      "data-toggle": "dropdown"
    }
  }, [_vm._v("\n                      Task "), _c('span', {
    staticClass: "caret"
  }), _vm._v(" "), _c('span', {
    staticClass: "sr-only"
  }, [_vm._v("Toggle Dropdown")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('li', [_c('a', {
    attrs: {
      "href": "#"
    }
  }, [_vm._v("...")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("File Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Payment Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                COLLECT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Processing Fee Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Payment Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                COLLECT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Insurance Fee Charge")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('label', [_vm._v("\n                            Payment Date\n                            "), _c('span', {
    staticClass: "red"
  }, [_vm._v("*")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-success",
    attrs: {
      "type": "submit"
    }
  }, [_vm._v("\n                COLLECT\n              ")]), _vm._v(" "), _c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n                CANCEL\n              ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "120px",
      "height": "140px",
      "float": "right",
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("Customer Photo "), _c('br'), _vm._v("with Cross Sign")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Address Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Address ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("District/State/Pincode ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Bank Details")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Applied Loan Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Income Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Guarantor Details : ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("((সদস্যের স্বাক্ষর))")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(গ্যারেন্টারের স্বাক্ষর)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(শাখা সিল স্বাক্ষর সহ)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Sr. No")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("EMI Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Amount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("((সদস্যের স্বাক্ষর))")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(গ্যারেন্টারের স্বাক্ষর)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(শাখা সিল স্বাক্ষর সহ)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("ঋণ নিম্নলিখিত নিয়ম সাপেক্ষে: -")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "1px",
      "width": "100%",
      "font-size": "12px",
      "bottom": "20px"
    }
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("((সদস্যের স্বাক্ষর))")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(গ্যারেন্টারের স্বাক্ষর)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(শাখা সিল স্বাক্ষর সহ)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Loans is subject to the following rules:-")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "1px",
      "width": "100%",
      "font-size": "12px",
      "bottom": "20px"
    }
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("((সদস্যের স্বাক্ষর))")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(গ্যারেন্টারের স্বাক্ষর)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(শাখা সিল স্বাক্ষর সহ)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("नियम और शर्ते")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "1px",
      "width": "100%",
      "font-size": "12px",
      "bottom": "20px"
    }
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('strong', [_vm._v("Terms and Condition")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table",
    staticStyle: {
      "width": "100%"
    }
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('thead', [_c('th', [_vm._v("Branch Manager Signature")]), _vm._v(" "), _c('th', [_vm._v("Customer Signature")]), _vm._v(" "), _c('th', [_vm._v("Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Loan Amount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Number of EMI ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("EMI Amount - ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Sr. No")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Loan EMI Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Amount")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Receiving Date")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Received Amt")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Staff Sign")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "1px",
      "width": "100%"
    }
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "rowspan": "3"
    }
  }, [_c('div', {
    staticStyle: {
      "border-width": "3px",
      "border-style": "solid",
      "width": "120px",
      "height": "140px",
      "float": "right",
      "text-align": "center"
    }
  }, [_c('br'), _vm._v("Customer "), _c('br'), _vm._v(" & "), _c('br'), _vm._v("Guarantor Photo "), _c('br'), _vm._v("with Cross Sign")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('strong', [_vm._v("Address Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Address ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("District/State/Pincode ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('tr', [_c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Bank Details :")])]), _vm._v(" "), _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Applied Loan Details")])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Account Number : ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "2"
    }
  }, [_c('strong', [_vm._v("Income Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', {
    attrs: {
      "colspan": "3"
    }
  }, [_c('strong', [_vm._v("Guarantor Details : ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('td', [_c('strong', [_vm._v("Name : ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', [_c('table', {
    staticClass: "table",
    staticStyle: {
      "border-width": "1px",
      "width": "95%",
      "position": "absolute",
      "bottom": "25px"
    }
  }, [_c('thead', [_c('th', [_vm._v("Member Signature "), _c('br'), _vm._v("(सदस्या के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Guarantor Signature "), _c('br'), _vm._v("(जमानतदार के हस्ताक्षर)")]), _vm._v(" "), _c('th', [_vm._v("Branch Seal With Signature "), _c('br'), _vm._v("(शाखा मोहर के साथ हस्ताक्षर)")])])])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-header bg-aqua"
  }, [_c('button', {
    staticClass: "close",
    attrs: {
      "type": "button",
      "data-dismiss": "modal",
      "aria-label": "Close"
    }
  }, [_c('span', {
    attrs: {
      "aria-hidden": "true"
    }
  }, [_vm._v("×")])]), _vm._v(" "), _c('h4', {
    staticClass: "modal-title"
  }, [_vm._v("Loan Details")])])
},function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "modal-footer text-center"
  }, [_c('button', {
    staticClass: "btn btn-danger",
    attrs: {
      "type": "button",
      "data-dismiss": "modal"
    }
  }, [_vm._v("\n              CLOSE\n            ")])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-0ecb199c!./~/vue-loader/lib/selector.js?type=template&index=0!./src/microfinance/Loan/GroupMemberDisbursment.vue
// module id = 791
// module chunks = 0